/**
 * Created by shiyonggao on 2019/11/28.
 */
import {
    forIn,
    forEach,
    cloneDeep,
    keys,
    findKey,
    isEmpty,
    unescape,
    isPlainObject,
    isFunction,
    toString,
    size
} from "lodash";
import Cookie from "./cookie";
import LocalStorage from "./localStorage";
import qs from "qs";

const Config = require("../config/config");
import Axios from "axios";

class Helper {
    /***
     * 去掉两端空格
     * @param s
     * @returns {s}
     */
    tirm(s) {
        return s.replace(/^\s+|\s+$/gm, "");
    }

    /**
     * 清除缓存在本地Cookie和localStorage中的数据
     */
    clearCookie() {
        let cookieArrkes = [
            "odp-baseSdkSelectedPlatfrom",
            "odp-projectType",
            "odp-selectedGameCode",
            "odp-projectType-hide",
            "access-token",
            "oasis-ces-token",
            "oasis-udc-token",
            "oasis-watch-token",
            "oasis-odp5-token",
            "odp5-access-token",
            "oasis-passport-token"
        ];
        let len = cookieArrkes.length;
        for (let i = 0; i < len; i++) {
            Cookie.remove(cookieArrkes[i]);
        }

        LocalStorage.remove("odp_gameList");
    }

    /**
     * 用户登陆页面
     */
    login() {
        console.log("Jump UDP login url");
        this.clearCookie();
        let p = window.location.pathname,
            g = this.getGameCode().game_code;
        p = p.replace(/\.html$/, "").replace(/^\//, "");
        window.location.href = `${Config.userLogin}?game_code=${g}&page=${p}`;
    }

    /**
     * 用户退出
     */
    logout() {
        this.token = this.getToken();
        let headers = {};
        if (this.token) {
            headers[Config.userLoginAccessTokenKey] = this.token;
        }
        let axios = Axios.create({
            timeout: 120 * 60,
            responseType: "json",
            baseURL: Config.apiBaseUrl,
            headers: headers
        });

        let haddle = () => {
            /**跳转退出页面**/
            window.location.href = `${Config.baseUrl}${Config.userLogout}`;
        };

        /**清除ODPcookie**/
        this.clearCookie();

        /**用户退出**/
        axios
            .get(Config.userLogoutApi)
            .then(() => {
                haddle();
            })
            .catch(() => {
                haddle();
            });
        /**Core 退出**/
        // let coreUrl = Config.coreUrl;
        // let appId = Config.coreAppId;
        // let oauthUrl = Config.coreOauthUrl;
        // let redirectUrl = `${oauthUrl}/oauth/authorize?response_type=code&client_id=${appId}`;
        // window.location.href = `${coreUrl}/panel/logout?redirect_uri=${encodeURIComponent(redirectUrl)}`;
    }

    /**
     * unset 对象特定的key
     * @param key
     * @param obj
     */
    unsetObject(key, obj) {
        let temp = {};
        for (let k in obj) {
            if (key === k) continue;
            else temp[k] = obj[k];
        }
        return temp;
    }

    /**
     * 获取当前key的上一个key的值
     * @param key
     * @param obj
     */
    prevObjectValue(key, obj) {
        let temp;
        for (let k in obj) {
            if (key === k) break;
            else {
                let te = {};
                te["key"] = k;
                te["value"] = obj[k];
                temp = te;
            }
        }
        return temp;
    }

    /**
     * 获取当前key的下一个key的值
     * @param key
     * @param obj
     */
    nextObjectValue(key, obj) {
        let temp = {};
        let active = false;
        for (let k in obj) {
            if (key === k) {
                active = true;
                continue;
            } else {
                if (active) {
                    temp["key"] = k;
                    temp["value"] = obj[k];
                    break;
                }
            }
        }
        return temp;
    }

    /**
     * 获取游戏code
     * @returns {{gameCode: string}}
     */
    getGameCode() {
        // let gamecode = {};
        // if (Cookie.get("odp-selectedGameCode")) {
        //     gamecode["game_code"] = Cookie.get("odp-selectedGameCode");
        // }
        return {
            game_code: this.getParamter("game_code")
        };
    }

    /**
     * 获取用户token，无用户token直接去登陆
     * @returns {null}
     */
    getToken() {
        let token = Cookie.get(Config.userLoginAccessTokenKey);
        console.log("getToken", token);

        /**无用户登陆跳转到登陆页面**/
        if (!token) {
            this.login();
        }
        return token;
    }

    /**
     * 获取用户token，无用户token直接去登陆
     * @returns {null}
     */
    getUdcToken() {
        let token = Cookie.get(Config.udcAccessTokenKey);
        console.log("getUdcToken", token);
        return token;
    }

    /**
     * 路由跳转
     * @param routeName
     * @param data
     * @param blank
     */
    route(routeName, data = {}, blank = false) {
        if (routeName === "index") {
            data = {};
        }
        if (!data["game_code"]) {
            data = Object.assign({}, data, this.getGameCode());
        }
        let params = this.paramJSON(data);
        let reg = /^((http|https):\/\/)\S+(\.html)$/;
        let url = "";
        /**有参数设置参数**/
        if (params) params = `?${params}`;

        if (reg.test(routeName)) {
            url = `${routeName.toLocaleLowerCase()}${params}`;
        } else {
            url = `${
                Config.baseUrl
            }${routeName.toLocaleLowerCase()}.html${params}`;
        }
        if (blank) {
            window.open(url);
        } else {
            window.location.href = url;
        }
    }

    getUrlParams() {
        let urlParams = window.location.search;
        if (urlParams) {
            urlParams = urlParams.substr(1);
            urlParams = qs.parse(urlParams);
        } else {
            urlParams = {};
        }
        return urlParams;
    }

    /**
     * 获取URL参数
     * @param key
     * @returns {string}
     */
    getParamers(key) {
        let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return "";
    }

    /**
     * 获取URL参数
     * @param key
     * @returns {string}
     */
    getParamter(key) {
        return this.getParamers(key);
    }

    /***
     * 解析url地址
     * @param url
     * @returns {}
     */
    parseURL(url) {
        if (!url) url = window.location.href;
        let a = document.createElement("a");
        a.href = url;
        return {
            source: url,
            protocol: a.protocol.replace(":", ""),
            host: a.hostname,
            port: a.port,
            query: a.search,
            params: (function () {
                let ret = {},
                    seg = a.search.replace(/^\?/, "").split("&"),
                    len = seg.length,
                    i = 0,
                    s;
                for (; i < len; i++) {
                    if (!seg[i]) {
                        continue;
                    }
                    s = seg[i].split("=");
                    if (s[1]) {
                        ret[s[0]] = decodeURI(s[1]);
                    }
                }
                return ret;
            })(),
            file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ""])[1],
            hash: a.hash.replace("#", ""),
            path: a.pathname.replace(/^([^\/])/, "/$1"),
            relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ""])[1],
            segments: a.pathname.replace(/^\//, "").split("/")
        };
    }

    /**
     * object to request params
     * @param o
     * @returns string   b=1&b=2
     */
    paramJSON(o) {
        let s = [],
            add = (key, valueOrFunction) => {
                let value = isFunction(valueOrFunction)
                    ? valueOrFunction()
                    : valueOrFunction;
                s[s.length] =
                    encodeURIComponent(key) +
                    "=" +
                    encodeURIComponent(value == null ? "" : value);
            },
            buildParams = (prefix, obj) => {
                if (Array.isArray(obj)) {
                    obj.forEach((value, i) => {
                        buildParams(
                            prefix +
                            "[" +
                            (typeof value === "object" && value != null
                                ? i
                                : "") +
                            "]",
                            value
                        );
                    });
                } else if (isPlainObject(obj)) {
                    forIn(obj, (value, key) => {
                        buildParams(prefix + "[" + key + "]", value);
                    });
                } else {
                    add(prefix, obj);
                }
            };

        if (isEmpty(o)) {
            return "";
        }

        forIn(o, (value, prefix) => {
            buildParams(prefix, value);
        });

        return s.join("&");
    }

    /**
     * version1>version2 返回1，version1<version2 返回-1，version1=version2 返回0
     *
     * @param version1
     * @param version2
     * @returns {number}
     */
    compareVersion(version1, version2) {
        let arr1 = version1.split(".");
        let arr2 = version2.split(".");

        let len = Math.max(arr1.length, arr2.length);
        for (let i = 0; i < len; i++) {

            let data1 = 0, data2 = 0;
            if (i < arr1.length) {
                data1 = parseInt(arr1[i]);
            }
            if (i < arr2.length) {
                data2 = parseInt(arr2[i]);
            }

            if (data1 < data2) {
                return -1;
            } else if (data1 > data2) {
                return 1;
            }
        }
        return 0;
    }
}

export default new Helper();



// WEBPACK FOOTER //
// ./website/helper/helper.js